import { Lemonade, setConfig, useLemonadeEditor } from '@oneclick/react-lemonade-editor';
import { useUser } from 'core/lite/hooks/useUser';
import * as coreEntities from 'core/store/index';
import { LEMONADE_EDITOR_ACTIONS } from 'core/utils/lemonade';
import React, { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

export function useLemonadeEditorViewer({ data, defaultData, uploadURL, onClickFeedbackAi }) {
  const language = useSelector((state) => coreEntities.i18n.selectors.getLanguage(state));
  const { user } = useUser();
  const [editorData, setEditorData] = useState({});

  let {
    exercise: { Editor, Question, editorApi: store },
  } = useLemonadeEditor({ data: data, defaultData: defaultData, lang: language, assetsEditorApi: uploadURL });

  //TODO: Revisar si podemos utilizar defaultData en futuras versiones de lemonade, ya que ahora (v3.17.1) nos devuelve un data incompleto y es problemático
  // useEffect(() => {
  //   //La función getDefaultData es una función de @oneclick/react-lemonade-editor que se encarga de darnos el objeto de lemonade según el template que le pasemos
  //   //Lo seteamos antes de que el usuario toque el editor para que no se guarde un content con un data vacío
  //   if (defaultData) setEditorData(getDefaultData(defaultData));
  // }, []);

  useEffect(() => {
    if (user) setConfig({ showSampleAnswer: true, showAIFeedbackGenerator: false, maxUploadFileSize: 100 });
  }, [user]);

  const setApiConfig = (endpoint) => {
    if (store) {
      store.setAssetsEditorApi(endpoint);
    }
  };

  const QuestionComponent = useCallback(
    () => (
      <Lemonade>
        <Question showFeedback={true} showReset={true} showCheckAnswer={true} showPoints={false} />
      </Lemonade>
    ),
    []
  );

  const EditorComponent = useCallback(
    () => (
      <Editor
        changed={(output) => {
          setEditorData(output);
        }}
        onActionPerformed={(action, payload) => {
          if (action === LEMONADE_EDITOR_ACTIONS.FEEDBACK_AI && onClickFeedbackAi) {
            onClickFeedbackAi();
          }
        }}
      />
    ),
    []
  );

  return {
    // Values
    store,
    editorData,
    setApiConfig,
    // Components
    Question: QuestionComponent,
    Editor: EditorComponent,
  };
}
